import { render, staticRenderFns } from "./BaseModalCrop.vue?vue&type=template&id=964da4ec&scoped=true"
import script from "./BaseModalCrop.vue?vue&type=script&lang=js"
export * from "./BaseModalCrop.vue?vue&type=script&lang=js"
import style0 from "./BaseModalCrop.vue?vue&type=style&index=0&id=964da4ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964da4ec",
  null
  
)

export default component.exports